// src/utils/ids/generate-pushid/generate-pushid.ts
var PUSH_CHARS = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz";
var UniqueIdGenerator = class _UniqueIdGenerator {
  // Timestamp of last push, used to prevent local collisions if you push twice in one ms.
  static lastPushTime = 0;
  // We generate 72-bits of randomness which get turned into 12 characters and appended to the
  // timestamp to prevent collisions with other clients.  We store the last characters we
  // generated because in the event of a collision, we'll use those same characters except
  // "incremented" by one.
  static lastRandChars = [];
  // Generates chronologically orderable unique string one by one
  static generate() {
    let now = (/* @__PURE__ */ new Date()).getTime();
    let duplicateTime = Boolean(now === _UniqueIdGenerator.lastPushTime);
    _UniqueIdGenerator.lastPushTime = now;
    let timeStampChars = new Array(8);
    let i;
    for (i = 7; i >= 0; i -= 1) {
      timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
      now = Math.floor(now / 64);
    }
    let id = timeStampChars.join("");
    if (!duplicateTime) {
      for (i = 0; i < 12; i += 1) {
        _UniqueIdGenerator.lastRandChars[i] = Math.floor(Math.random() * 64);
      }
    } else {
      for (i = 11; i >= 0 && _UniqueIdGenerator.lastRandChars[i] === 63; i -= 1) {
        _UniqueIdGenerator.lastRandChars[i] = 0;
      }
      _UniqueIdGenerator.lastRandChars[i] += 1;
    }
    for (i = 0; i < 12; i += 1) {
      id += PUSH_CHARS.charAt(_UniqueIdGenerator.lastRandChars[i]);
    }
    return id;
  }
};
var generatePushId = () => UniqueIdGenerator.generate();
var generate_pushid_default = generatePushId;

export {
  generate_pushid_default
};
